import React from 'react';
import { X } from 'lucide-react';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-165">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-166"></div>

      {/* Modal */}
      <div className="relative bg-white rounded-3xl shadow-2xl max-w-4xl w-full max-h-[85vh] flex flex-col z-10" data-id="element-167">
        {/* Header */}
        <div className="flex items-center justify-between p-6 md:p-8 border-b border-gray-100 flex-shrink-0" data-id="element-168">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-169">
            Política de Privacidad y Protección de Datos
          </h2>
          <button onClick={onClose} className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors flex-shrink-0" data-id="element-170">
            <X className="w-5 h-5 text-gray-600" data-id="element-171" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed" data-id="element-172">
          <p data-id="element-173">
            Las siguientes Políticas de Privacidad y Protección de Datos son
            aplicables a todas nuestras plataformas, incluyendo nuestro sitios
            web, APPs, terminales de auto-atención y puntos presenciales. Las
            mismas regulan el tratamiento y protección de los datos de carácter
            personal de los usuarios registrados con la finalidad de realizar
            Pagos de Servicios Públicos y Privados, Recargas de Prepagos y/o
            cualquier otra transacción a través de nuestra plataforma.
          </p>
          <p data-id="element-174">
            Al accesar, usted está aceptando, sin ninguna limitación, los
            términos y condiciones descritos a continuación:
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-175">
            Uso de los Datos Personales Registrados en Nuestras Plataformas
          </h3>
          <p data-id="element-176">
            Los datos referidos en estas políticas para el registro y para toda
            operación en línea, tendrán como finalidad validar las transacciones
            de pagos y mejorar la labor de información y comercialización de los
            productos y servicios prestados por ZUMPAGO.
          </p>
          <p data-id="element-177">ZUMPAGO utilizará la información para:</p>
          <ul className="list-disc pl-6 space-y-3" data-id="element-178">
            <li data-id="element-179">
              El propósito específico para el cual se la suministró: pagos por
              sus canales a través de tarjetas de crédito, débito, giftcard u
              otros medios.
            </li>
            <li data-id="element-180">
              Realizar solicitudes de reclamos para mejorar el servicio hacia
              nuestros clientes.
            </li>
            <li data-id="element-181">
              Contactar a cada usuario con fines comerciales para darle a
              conocer promociones o información importante sobre su cuenta, así
              como ofrecerte la venta de productos o servicios que podrían
              resultar de su interés.
            </li>
            <li data-id="element-182">
              Efectuar análisis conducentes a comprender a nuestros clientes
              para mejoras de nuestros servicios.
            </li>
            <li data-id="element-183">
              Aplicar estudios sobre los impactos de las campañas promocionales
              o publicitarias de ZUMPAGO.
            </li>
            <li data-id="element-184">
              Promover todos los protocolos o medidas de seguridad financiera,
              mitigar los riesgos o fraudes en los servicios que ofrecemos.
            </li>
            <li data-id="element-185">
              Utilizar la información personal para fines comerciales legítimos:
              Esto incluye el uso de información personal para analizar y
              mejorar nuestros productos, ubicaciones, servicios, operaciones,
              el funcionamiento de este sitio y la experiencia como cliente, y
              para medir el retorno de la inversión en marketing y la
              satisfacción de la marca. Esto puede incluir el uso de tu
              información para realizar estudios de mercado. También se podrá
              utilizar la información personal para proporcionar servicios a
              clientes y para ayudar a proteger la seguridad e integridad de
              nuestra tecnología, sistemas y servicios.
            </li>
            <li data-id="element-186">
              Utilizar la información personal con fines legales y de
              cumplimiento: esto incluye el uso de la información personal
              necesaria para cumplir con las obligaciones legales y regulatorias
              relacionadas con el antiblanqueo de dinero y contra la
              financiación del terrorismo; la detección, prevención y
              persecución del fraude y el robo, así como la prevención del uso
              ilegítimo o prohibido de nuestros servicios u otras actividades
              ilegales o ilícitas. Esto también puede incluir el
              establecimiento, el ejercicio o la defensa de los derechos y
              reivindicaciones legales de ZUMPAGO y otros, así como la
              vigilancia y el informe de asuntos de cumplimiento. Esto puede
              incluir además el uso de la información personal para validar y
              autenticar identidad, y la utilización de terceros para ayudarnos
              a hacerlo.
            </li>
          </ul>
          <p data-id="element-187">
            Cuando registra datos personales, estará automáticamente autorizando
            a ZUMPAGO a usar los datos personales de conformidad con esta
            Política de Privacidad y Protección de Datos.
          </p>
          <p data-id="element-188">
            Toda esta información será tratada como confidencial y su manejo se
            rige por la Política de Seguridad de ZUMPAGO, que puede ser
            observada en el sitio www.zumpago.com
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-189">
            Políticas de Creación de usuario
          </h3>
          <p data-id="element-190">
            El Usuario elegirá su propio identificador y contraseña. Para la
            elección del identificador, el Usuario no podrá optar por
            expresiones, palabras o conjuntos de letras que puedan resultar
            insultantes, injuriosos o contrarios a la ley, a la moral y a las
            buenas costumbres. De igual modo, tampoco podrá utilizar marcas,
            rótulos de establecimientos, expresiones publicitarias, nombres y
            pseudónimos de personajes públicos o conocidos sin su autorización.
            ZUMPAGO asignará el identificador seleccionado por el Usuario,
            siempre y cuando no haya sido previamente seleccionado por otro
            Usuario, en este caso no habrá reclamo alguno. El uso de la
            contraseña es personal e intransferible, no estando permitida la
            cesión, ni siquiera temporal, a terceros. En tal sentido, el Usuario
            se compromete a hacer un uso diligente y a mantener en secreto la
            misma, asumiendo toda responsabilidad por las consecuencias de su
            divulgación a terceros.
          </p>
          <p data-id="element-191">
            En el supuesto de que el Usuario conozca o sospeche del uso de su
            contraseña por terceros, deberá poner tal circunstancia en
            conocimiento de ZUMPAGO con la mayor brevedad posible, a fin de
            restringir el acceso de dicha contraseña.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-192">
            Bloqueo de usuario
          </h3>
          <p data-id="element-193">
            Por seguridad del cliente, la cuenta de usuario puede bloquearse
            automáticamente luego de detectar diversos intentos fallidos al
            ingresar la contraseña.
          </p>
          <p data-id="element-194">
            Para desbloquear la cuenta de usuario por este motivo, el cliente
            deberá utilizar la opción de recuperar contraseña del sitio web o
            APP de ZUMPAGO. En caso de que esta opción no sea viable, podrá
            solicitar ello al e-mail del área de soporte:{' '}
            <a href="mailto:contacto@zumpago.com" className="text-zumpago-red hover:underline" data-id="element-195">
              contacto@zumpago.com
            </a>
            , quienes atenderán su solicitud y procederán con el desbloqueo del
            mismo luego de validar la identidad del que lo solicita.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-196">
            Principios aplicados en el tratamiento de datos
          </h3>
          <p data-id="element-197">
            En el tratamiento de los datos personales, ZUMPAGO aplicará los
            siguientes principios que se ajustan a las exigencias de protección
            de datos:
          </p>
          <ul className="list-disc pl-6 space-y-3" data-id="element-198">
            <li data-id="element-199">
              <strong data-id="element-200">Principio de licitud, lealtad y transparencia:</strong>{' '}
              ZUMPAGO siempre requerirá el consentimiento para el tratamiento de
              los datos personales que puede ser para uno o varios fines
              específicos sobre los que se informará previamente con absoluta
              transparencia.
            </li>
            <li data-id="element-201">
              <strong data-id="element-202">Principio de minimización de datos:</strong> ZUMPAGO
              solicitará solo los datos estrictamente necesarios para el fin o
              los fines que los solicita.
            </li>
            <li data-id="element-203">
              <strong data-id="element-204">
                Principio de limitación del plazo de conservación:
              </strong>{' '}
              Los datos se mantendrán durante el tiempo estrictamente necesario
              para el fin o los fines del tratamiento. ZUMPAGO informará del
              plazo de conservación correspondiente según la finalidad.
            </li>
            <li data-id="element-205">
              <strong data-id="element-206">Principio de integridad y confidencialidad:</strong> Los
              datos serán tratados de tal manera que la seguridad,
              confidencialidad e integridad esté garantizada. ZUMPAGO realiza
              las mejores prácticas y precauciones necesarias para evitar el
              acceso no autorizado o uso indebido de los datos de sus usuarios
              por parte de terceros.
            </li>
          </ul>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-207">
            Seguridad de los datos personales
          </h3>
          <p data-id="element-208">
            Para proteger los datos personales, ZUMPAGO toma todas las
            precauciones razonables y sigue las mejores prácticas de la
            industria para evitar su pérdida, mal uso, acceso indebido,
            divulgación, alteración o destrucción de los mismos.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-209">
            Exactitud y veracidad de los datos personales
          </h3>
          <p data-id="element-210">
            Cada usuario se compromete a que los datos facilitados a ZUMPAGO
            sean correctos, completos, exactos y vigentes, así como a
            mantenerlos debidamente actualizados.
          </p>
          <p data-id="element-211">
            Cada Usuario de las plataformas es el único responsable de la
            veracidad y corrección de los datos que remita al sitio, exonerando
            a ZUMPAGO de cualquier responsabilidad al respecto.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-212">
            Propiedad intelectual
          </h3>
          <p data-id="element-213">
            Los derechos de propiedad intelectual contenidos en las plataformas
            de ZUMPAGO se encuentran protegidos por las leyes aplicables a la
            materia. En consecuencia, los elementos aquí incluidos (fotos,
            diseños, logos, entre otros), no pueden ser reproducidos, usados,
            adaptados o comercializados por este u otros medios sin la
            existencia de la aprobación previa y escrita de ZUMPAGO.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-214">
            Aceptación y consentimiento
          </h3>
          <p data-id="element-215">
            Al utilizar las plataformas u otro canal de ZUMPAGO, usted declara
            haber sido informado de las condiciones sobre protección de datos de
            carácter personal, y acepta y consiente el tratamiento de los mismos
            por parte ZUMPAGO en la forma y para las finalidades indicadas en
            esta Política de Privacidad y Protección de Datos.
          </p>
          <p data-id="element-216">El tratamiento de tus datos se realiza con base en:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-217">
            <li data-id="element-218">Tu consentimiento expreso.</li>
            <li data-id="element-219">
              El interés legítimo de ZUMPAGO para cumplir su misión
              institucional.
            </li>
            <li data-id="element-220">
              El cumplimiento de obligaciones legales, según la normativa
              ecuatoriana aplicable (Ley Orgánica de Protección de Datos
              Personales – LOPDP).
            </li>
          </ul>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-221">
            Derechos del titular de los datos
          </h3>
          <p data-id="element-222">Tienes derecho a:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-223">
            <li data-id="element-224">Acceder a tus datos personales</li>
            <li data-id="element-225">Rectificar datos inexactos o incompletos</li>
            <li data-id="element-226">Eliminar tus datos (cuando proceda)</li>
            <li data-id="element-227">Oponerte al tratamiento</li>
            <li data-id="element-228">Solicitar la portabilidad de tus datos</li>
            <li data-id="element-229">Revocar el consentimiento en cualquier momento</li>
          </ul>
          <p data-id="element-230">
            Puedes ejercer estos derechos escribiéndonos a{' '}
            <a href="mailto:protecciondatos@zumpago.com" className="text-zumpago-red hover:underline" data-id="element-231">
              protecciondatos@zumpago.com
            </a>
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-232">
            Cambios en la Política de Privacidad
          </h3>
          <p data-id="element-233">
            ZUMPAGO se reserva el derecho a modificar la presente Política de
            Privacidad y Protección de Datos para adaptarla a novedades
            legislativas o jurisprudenciales, así como a prácticas de la
            industria.
          </p>
          <p className="text-sm text-gray-500 pt-4 border-t border-gray-100" data-id="element-234">
            La vigencia de estas Políticas de Privacidad y Protección de Datos
            es desde el 30 de marzo de 2025 y permanecerá vigente hasta que
            exista una nueva versión que la reemplace.
          </p>
        </div>
      </div>
    </div>;
}